import { useMutation } from '@apollo/client'
import classnames from "classnames";
import { AuthContext } from 'AuthContext'
import { EledoFormGenerator, EledoPageHeader, EledoPendingContent } from 'components/library'
import { useShowMenu } from 'hooks'
import React, { useContext, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import styles from 'components/library/EledoPageHeader.module.scss';
import { LoginStartFormModel } from 'model/login';
import { GET_IDENTIFY, IdentifyDataData, IdentifyVars } from 'graphql/AuthQueries';

type LoginStartFormData = {
  login: string
}

type LocationState = {
  from: {
    pathname: string
    search: string
  }
}

const EledoLoginStart = () => {

  const auth = useContext(AuthContext);
  const navigate = useNavigate()
  const state = useLocation().state as LocationState;
  const [error, setError] = useState<string>()

  const [doIdentify, { loading }] = useMutation<IdentifyDataData, IdentifyVars>(GET_IDENTIFY, {
    onCompleted(data, clientOptions) {
      if(data){
        console.log(clientOptions)
        console.log(data)
        if(data.identify.userId === null){
          setError("Eledo account doesn't exist.")
          return
        }

        const userId = data.identify.userId
        const authMethods = data.identify.authMethods
        if(authMethods === null || authMethods.length < 1) {
          return navigate('/recovery')
        }

        if(authMethods?.includes('SSO')) {
          return navigate('/login/sso', { state: { email: clientOptions?.variables?.email, userId }})
        }

        if(authMethods?.includes('Password')) {
          return navigate('/login/password', { state: { ...state, email: clientOptions?.variables?.email, userId }})
        }          
      }
    },
    onError(error){
      setError(error.message)
    }
  });
  
  // useEffect(() => {
  //   if(auth.user != null){
  //     if(state?.from?.pathname){
  //       navigate(state.from.pathname + state.from.search);
  //     }else{
  //       navigate("/templates/mine");
  //     }
  //   }
  // }, [platform, auth, navigate, state?.from?.pathname, state?.from?.search]);

  const formHandler = useForm<LoginStartFormData>({mode: "onChange"});
  const { formState: {isValid, isSubmitted} } = formHandler;

  useShowMenu();

  const onSubmitHandler = (data: LoginStartFormData) => {
    if(isValid) {
      doIdentify({ variables: { email: data.login}})
    }
  }

  if(!auth.canLetLogin){
    return (
      <Navigate to={{pathname: '/start'}}/>
    )
  }

  return (
    <div>
      <EledoPageHeader/>

      <div className={classnames(styles.EledoLogin, "container")} data-testid="EledoLogin">
        <div className="section section-small">
          <div className="hero-paragraph text-center">
            <h2><b>Log in to your account</b></h2>
          </div>
          <div style={{width: '330px', margin: '0 auto'}}>
            <div>
              <button onClick={() => { navigate('/login/sso', { state: { provider: 'google' }})}} className="button outline w-button"
                style={{position: 'relative', width: '100%', marginTop: '20px'}}>
                <div style={{display: 'flex'}}>
                  <div style={{width: '23px', height: '23px'}}>
                    <svg style={{display: 'block'}} height="21" viewBox="0 0 256 262" width="21" xmlns="http://www.w3.org/2000/svg"><title>Google Logo</title><path d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" fill="#4285F4"></path><path d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" fill="#34A853"></path><path d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" fill="#FBBC05"></path><path d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" fill="#EB4335"></path></svg>
                  </div>
                  <div style={{flexGrow: 1}}>
                    <span style={{verticalAlign: 'middle'}}>Continue with Google</span>							
                  </div>
                </div>
              </button>
            </div>
            <div style={{display: 'flex', alignItems: 'center', margin: '20px 0'}}>
              <hr style={{width: '100%', height: 0, margin: 0}}/><span style={{padding: '0px 20px'}}>OR</span><hr style={{width: '100%', margin: 0}}/>
            </div>
            <FormProvider {...formHandler}>
              <form onSubmit={formHandler.handleSubmit(onSubmitHandler)}>
                <div style={{width: "20rem"}} className="center">
                  <EledoFormGenerator formModel={LoginStartFormModel}
                                      editedDataObject={{}}/>

                  {error !== undefined && <span className="center text-center" style={{display: "block"}}>
                    <small className="error-message" style={{float: "initial"}}>{error}</small>
                  </span>}

                  <div className="hero-paragraph text-center">
                    <span data-tip={isSubmitted || isValid || loading ? "" : "Please check your credentials before logging in"}
                          data-for={isSubmitted || isValid || loading ? "" : 'login-button-tooltip'}>
                      <button className={"button"} type="submit"
                            {...(isValid ? {} : {"aria-disabled": "true"})}>
                        <EledoPendingContent state={loading}
                                            content="Continue"
                                            pendingContent="Working..."/>
                      </button>
                    <ReactTooltip
                      id="login-button-tooltip"
                      place="right"
                      type="warning"
                      effect="float"
                      multiline={true}
                    />
                    </span>
                  </div>


                  <p className="hero-paragraph"/>
                  <p style={{lineHeight: "100%", textAlign: "center"}}>
                    Don't have an account yet? <a href={`${process.env.REACT_APP_ELEDO_BASE_URL}/register`} target="_blank" rel="noreferrer">Sign up</a>
                  </p>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  )

}

export default EledoLoginStart